<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
@if (navigationCategory$ | async; as category) { @if (category.name) {
<li
  #subMenu
  class="dropdown main-nav"
  [ngClass]="{ open: isOpened(category.uniqueId) }"
  (mouseenter)="subMenuShow(subMenu)"
  (mouseleave)="subMenuHide(subMenu)"
  (click)="subMenuHide(subMenu)"
>
  @if (category.name) {
  <a
    [routerLink]="category.url"
    [attr.data-testing-id]="category.uniqueId + '-link'"
    [ngStyle]="{ width: !(0 < mainNavigationMaxSubCategoriesDepth && category.hasChildren) ? '100%' : '' }"
    class="main-navigation-link single-category-navigation"
    [ngClass]="{ 'without-sub-menu': !category.hasChildren }"
  >
    {{ this.pagelet().stringParam('AlternateNavigationTitle') || category.name }}
  </a>
  } @if (0 < mainNavigationMaxSubCategoriesDepth && category.hasChildren) {
  <a
    [routerLink]="[]"
    class="dropdown-toggle"
    (click)="toggleOpen(category.uniqueId)"
    [attr.aria-label]="isOpened(category.uniqueId) ? 'collapse ' + category.name : 'expand ' + category.name"
  >
    @if (isOpened(category.uniqueId)) {
    <fa-icon [icon]="['fas', 'minus']" />
    } @else {
    <fa-icon [icon]="['fas', 'plus']" />
    }
  </a>
  <ish-sub-category-navigation [categoryUniqueId]="category.uniqueId" [subCategoriesDepth]="1" />
  }
</li>
} }
